import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { catchError, switchMap, take } from 'rxjs/operators';
import { environment } from '../../../assets/env/env.local';

const AUTH_ERRORS = ['login_required', 'consent_required', 'interaction_required', 'missing_refresh_token'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.API_BASE_URL)) {
      return next.handle(request);
    }

    return this.auth.isAuthenticated$.pipe(
      take(1),
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          return next.handle(request);
        }

        return this.auth.getAccessTokenSilently().pipe(
          catchError(error => {
            if (AUTH_ERRORS.includes(error?.error)) {
              this.auth.loginWithRedirect({
                appState: { target: window.location.pathname + window.location.search },
              });
            }
            return throwError(() => error);
          }),
          switchMap(token => {
            const authRequest = request.clone({
              setHeaders: { Authorization: `Bearer ${token}` },
            });
            return next.handle(authRequest);
          }),
        );
      }),
    );
  }
}
